<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label">Status</label>
                <select class="form-select" [(ngModel)]="item.status" name="shipment_status">
                    <option *ngFor="let status of shipmentStatuses" [value]="status">
                        {{getShipmentStatusLabel(status)}}
                    </option>
                </select>
            </div>
            <div class="col-md-6">
                <label class="form-label">Vervoerder</label>
                <input type="text" class="form-control" [(ngModel)]="item.carrier" name="shipment_carrier">
            </div>
            <div class="col-12">
                <label class="form-label">Track & trace</label>
                <input type="text" class="form-control" [(ngModel)]="item.tracking_number" name="shipment_tracking">
            </div>
            <div class="col-md-6">
                <label class="form-label">Ter attentie van</label>
                <input type="text" class="form-control" [(ngModel)]="item.shipping_name" name="shipment_name">
            </div>
            <div class="col-md-6">
                <label class="form-label">Land</label>
                <input type="text" class="form-control" [(ngModel)]="item.shipping_country" name="shipment_country">
            </div>
            <div class="col-12">
                <label class="form-label">Adres</label>
                <input type="text" class="form-control" [(ngModel)]="item.shipping_address" name="shipment_address">
            </div>
            <div class="col-md-4">
                <label class="form-label">Postcode</label>
                <input type="text" class="form-control" [(ngModel)]="item.shipping_postal_code" name="shipment_postal_code">
            </div>
            <div class="col-md-8">
                <label class="form-label">Plaats</label>
                <input type="text" class="form-control" [(ngModel)]="item.shipping_city" name="shipment_city">
            </div>
            <div class="col-12">
                <label class="form-label">Notitie</label>
                <textarea class="form-control" rows="3" [(ngModel)]="item.notes" name="shipment_notes"></textarea>
            </div>
        </div>

        <div class="shipment-items mt-4" *ngIf="item.id">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h5>Artikelen</h5>
                <span *ngIf="itemsLoading" class="spinner-border spinner-border-sm"></span>
            </div>

            <div class="text-muted py-3" *ngIf="!itemsLoading && shipmentItems.length < 1">
                Geen artikelen gekoppeld
            </div>

            <div class="shipment-line" *ngFor="let shipmentItem of shipmentItems">
                <span>{{getOrderItemLabel(shipmentItem.order_item_id)}}</span>
                <span class="shipment-line-actions">
                    {{shipmentItem.quantity}}x
                    <button type="button" class="btn btn-sm btn-link text-danger"
                        (click)="deleteShipmentItem(shipmentItem)">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </span>
            </div>

            <div class="row g-2 mt-2" *ngIf="orderItems && orderItems.length > 0">
                <div class="col-md-7">
                    <select class="form-select" [(ngModel)]="newItem.order_item_id" name="shipment_item">
                        <option value="">Artikel</option>
                        <option *ngFor="let orderItem of orderItems" [value]="orderItem.id">
                            {{orderItem.name}}
                        </option>
                    </select>
                </div>
                <div class="col-md-3">
                    <input type="number" min="1" class="form-control" [(ngModel)]="newItem.quantity"
                        name="shipment_quantity">
                </div>
                <div class="col-md-2">
                    <button type="button" class="btn btn-primary w-100" (click)="addShipmentItem()"
                        [disabled]="itemsLoading">
                        <i class="bi bi-plus-lg"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="alert alert-info mt-4" *ngIf="!item.id">
            Sla de verzending eerst op om artikelen te koppelen.
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-danger me-auto" *ngIf="item.id" (click)="deleteShipment()"
                [disabled]="loading">
                <i class="bi bi-trash me-1"></i>
                Verwijderen
            </button>
            <button type="button" class="btn btn-outline-primary" *ngIf="item.id" (click)="sendMail()"
                [disabled]="loading">
                <i class="bi bi-envelope me-1"></i>
                Mail versturen
            </button>
            <button type="button" class="btn btn-primary" (click)="save()" [disabled]="loading">
                Opslaan
            </button>
        </div>
    </div>
</div>
